import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { PropType, computed } from "vue";
import { IBookInterval, ILineInfo } from "@/domain/entities/lineInfo";
import useGetBusStopStartTime from "@/use/useGetBusStopStartTime";
import useGetBusStopEndTime from "@/use/useGetBusStopEndTime";
import useConvertTimeStrToMinutes from "@/use/useConvertTimeStrToMinutes";
import { useServiceStore } from "@/stores/serviceStore";
import LineInfoDetailDepartureTime from "./LineInfoDetailDepartureTime.vue";

import { ITurnBusLastSeatCount } from "@/types";


const __default__ = {
  name: "LineInfoDetailContent",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  lineInfo: {
    type: Object as PropType<ILineInfo>,
    required: true,
  },
  selectedTimeIndex: {
    type: Number,
    required: true,
  },
  isBusRunning: {
    type: Boolean,
    default: false,
  },
  turnBusLastSeatCountList: {
    type: Array as PropType<ITurnBusLastSeatCount[]>,
    default: () => [],
  },
  availableTimes: {
    type: Array as PropType<Array<string>>,
    required: true,
  },
  hasDifferentTimes: {
    type: Boolean,
    default: false,
  },
  dailyBookInterval: {
    type: Object as PropType<IBookInterval>,
  },
  monthlyBookInterval: {
    type: Object as PropType<IBookInterval>,
  },
  isInsideShuttle: {
    type: Boolean,
    default: false,
  },
},
  emits: ["onClickSelectTime", "showBusTimeTable", "onClickBusImageIcon", "onChangeSelectedBusOrder"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

_useCssVars(_ctx => ({
  "aabff04a-changeTimeBtnWidth": (changeTimeBtnWidth.value)
}))

const props = __props;

const emit = __emit;

const serviceStore = useServiceStore();
const shouldShowTurnList = computed(
  () => serviceStore.serviceInfo?.shouldShowTurnList ?? false
);

const onClickSelectTime = () => {
  if (!props.hasDifferentTimes) {
    return;
  }
  emit("onClickSelectTime");
};

/** 기점 출발 시간 UI 처리 */
const selectedTurnIndex = computed(() => props.selectedTimeIndex);
const currentTurn = computed(
  () => props.lineInfo.turns[props.selectedTimeIndex]
);

const calculatePreviousIndex = (currentIndex: number, turnLength: number) => {
  if (turnLength < 2) return undefined;
  if (turnLength === 2) return currentIndex === 0 ? undefined : 0;
  if (currentIndex === 0) return turnLength - 1;
  return currentIndex - 1;
};

const calculateNextIndex = (currentIndex: number, turnLength: number) => {
  if (turnLength < 2) return undefined;
  if (turnLength === 2)
    return currentIndex === turnLength - 1 ? undefined : turnLength - 1;
  if (currentIndex === turnLength - 1) return 0;
  return currentIndex + 1;
};

const previousDisplayTurnIndex = computed(() =>
  calculatePreviousIndex(props.selectedTimeIndex, props.lineInfo.turns.length)
);

const nextDisplayTurnIndex = computed(() =>
  calculateNextIndex(props.selectedTimeIndex, props.lineInfo.turns.length)
);

/** 노선 회차 시간 */
const getAvailableTimeStr = computed(() => {
  const startTime = useGetBusStopStartTime(props.lineInfo);
  const endTime = useGetBusStopEndTime(props.lineInfo);
  return `${startTime}~${endTime}`;
});

const calculateEarlyDriveTime = (
  earlyMinute: number,
  stopTime: string
): string => {
  const timeDiffMin = useConvertTimeStrToMinutes(stopTime) - earlyMinute;
  const hours = Math.trunc(timeDiffMin / 60);
  const minutes = timeDiffMin % 60;
  const formattingHours = hours < 10 ? `0${hours}` : `${hours}`;
  const formattingMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
  return `${formattingHours}:${formattingMinutes}`;
};

const getEarlyDriveTime = (earlyMinute: number) => {
  if (!props.isInsideShuttle) {
    const startTime = currentTurn.value.firstStop.departureTime;
    return calculateEarlyDriveTime(earlyMinute, startTime);
  }

  const startTime = useGetBusStopStartTime(props.lineInfo);
  const endTime = useGetBusStopEndTime(props.lineInfo);
  return `${calculateEarlyDriveTime(
    earlyMinute,
    startTime
  )}~${calculateEarlyDriveTime(earlyMinute, endTime)}`;
};

const changeTimeBtnWidth = computed(() =>
  props.hasDifferentTimes ? "57px" : "0px"
);

const __returned__ = { props, emit, serviceStore, shouldShowTurnList, onClickSelectTime, selectedTurnIndex, currentTurn, calculatePreviousIndex, calculateNextIndex, previousDisplayTurnIndex, nextDisplayTurnIndex, getAvailableTimeStr, calculateEarlyDriveTime, getEarlyDriveTime, changeTimeBtnWidth, LineInfoDetailDepartureTime }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})